import gql from 'graphql-tag'

export const LIST_QUERY_ORGANIZATIONS = gql`
  query ListOrganizationQuery($limit: Int!, $offset: Int!, $orgOrderBy: String!, $userId: String!,
                              $organizationName: String!, $organizationIsEmpty: Boolean!,
                              $organizationIsNull: Boolean!) {
    listWorkHistory(userId: $userId, orderBy: $orgOrderBy, organizationName: $organizationName,
                    organizationIsEmpty: $organizationIsEmpty, organizationIsnull: $organizationIsNull) {
      results(limit: $limit, offset: $offset) {
        id
        organization {
          id
          name
        }
      }
      totalCount
    }
  }
`

export const LIST_QUERY_TITLES = gql`
  query ListTitleQuery($limit: Int!, $offset: Int!, $titleOrderBy: String!, $userId: String!, $titleName: String!,
                       $titleIsEmpty: Boolean!, $titleIsNull: Boolean!) {
    listWorkHistory(userId: $userId, orderBy: $titleOrderBy, titleName: $titleName, titleIsEmpty: $titleIsEmpty,
                    titleIsnull: $titleIsNull) {
      results(limit: $limit, offset: $offset) {
        id
        title {
          id
          name
        }
      }
      totalCount
    }
  }
`
